import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    {...props}
  >
    <g
      stroke="#475CB0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      clipPath="url(#Refresh_svg__a)"
    >
      <path d="M19.168 3.832v5h-5M.832 17.168v-5h5" />
      <path d="M2.924 8.002a7.5 7.5 0 0 1 12.375-2.8l3.866 3.633M.832 12.17l3.867 3.633a7.5 7.5 0 0 0 12.375-2.8" />
    </g>
    <defs>
      <clipPath id="Refresh_svg__a">
        <path fill="#fff" d="M0 .5h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRefresh;
